import { getApiBaseUrl } from './cloudApi';

const getHeaders = (token) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

const categoriesApi = {
  async getAll(token) {
    const base = await getApiBaseUrl();
    const res = await fetch(`${base}/categories`, { headers: getHeaders(token) });
    return res.json();
  },

  async create(token, { name, color, icon }) {
    const base = await getApiBaseUrl();
    const res = await fetch(`${base}/categories`, {
      method: 'POST',
      headers: getHeaders(token),
      body: JSON.stringify({ name, color, icon }),
    });
    return res.json();
  },

  async update(token, id, { name, color, icon }) {
    const base = await getApiBaseUrl();
    const res = await fetch(`${base}/categories/${id}`, {
      method: 'PUT',
      headers: getHeaders(token),
      body: JSON.stringify({ name, color, icon }),
    });
    return res.json();
  },

  async remove(token, id) {
    const base = await getApiBaseUrl();
    const res = await fetch(`${base}/categories/${id}`, {
      method: 'DELETE',
      headers: getHeaders(token),
    });
    return res.json();
  },
};

export default categoriesApi;
